// eslint-disable-next-line import/prefer-default-export
export const paginateList = (items, page = 0, maxPerPage = 10) => {
  const startIndex = page * maxPerPage;
  const endIndex = Math.min(startIndex + maxPerPage - 1, items.length - 1);

  return items.slice(startIndex, endIndex + 1);
};
